import dashboards from './dashboards';
import apps from './apps';
import pages from './pages';
import cockpit, {
  assets,
  customers,
  maintenances,
  settings,
  booking,
} from './cockpit';
import userInterface from './user-interface';

const navigation = [
  ...dashboards,
  ...cockpit,
  ...maintenances,
  ...assets,
  ...customers,
  ...booking,
  ...settings,
];

export default navigation;
